import getRouter from './router';
import { playSfx } from './sfx';

export default function openLightbox(id: string) {
  const params = { ...getRouter().currentRoute.value.params, lightbox: id };
  getRouter().push({ params });
  playSfx('lightbox-open');
  // hide the main app template from screen readers
  document.querySelector('.app-template')?.setAttribute('aria-hidden', 'true');
}

export function closeLightbox() {
  const { page } = getRouter().currentRoute.value.params;
  getRouter().push(`/${page}`);
  playSfx('lightbox-close');
  document.querySelector('.app-template')?.removeAttribute('aria-hidden');
}

export function getOpenLightbox() {
  return getRouter()?.currentRoute.value.params.lightbox;
}
